// @ts-nocheck
import React, { Component } from "react";
import { treeElementTypes } from "../../../constants";
import { toast } from "react-toastify";
import { catchingErrorsMaxLengthFileName } from "../../../utils/util";
import ApiService from "../../../services/api.service";
import { AuthService } from "../../../services/auth.service";
import Select from "react-select";

export default class TreeCreationModal extends Component {
  constructor(props) {
    super(props);
    let isShowGlobal = this.checkUserVariableHaveGlobal(this.props.cursor);
    this.state = {
      fileName: {
        value:
          this.props.copyFile
            ? (this.props.actionElement?.name || "") + "Copy"
            : (!this.props.addFolder && !this.props.addFile ? this.props.actionElement && this.props.actionElement.name : ""),
        isValid: (this.props.actionElement && !!this.props.actionElement.name) || false,
        errMsg: null,
        users: []
      },
      groupTypes: [
        treeElementTypes.dataSource,
        treeElementTypes.flow,
        treeElementTypes.script,
        treeElementTypes.component
      ],
      users: [],
      selectedUsers: [],
      isNewFile: this.props.addFolder || this.props.addFile,
      isCopyFile: this.props.copyFile,
      isGlobal: false,
      isShowGlobal: isShowGlobal,
      crawlerUrl: "",
      crawlerPageLimit: 20,
      crawlerRequireAuth: false,
      loading: false,
      projects: this.props.data,
      cursor: this.props.cursor,
      elementType: this.props.actionElement?.contentType
        || this.props.actionElement?.elementType
        || 'item',
      isRoot: this.props.actionElement?.elementType === treeElementTypes.root,
      isProject: this.props.actionElement?.elementType === treeElementTypes.project
    };
    this.apiService = ApiService.getInstance();
  }

  async componentDidMount() {
    console.log("[TreeCreationModal] componentDidMount");
    console.log("[TreeCreationModal] props.addFolder:", this.props.addFolder);
    console.log("[TreeCreationModal] props.editFolder:", this.props.editFolder);
    console.log("[TreeCreationModal] state.isProject:", this.state.isProject);
    console.log("[TreeCreationModal] props.actionElement:", this.props.actionElement);
    console.log("[TreeCreationModal] props.actionElement?.elementType:", this.props.actionElement?.elementType);

    if (this.props.addFolder || this.state.isProject) {
      console.log("[TreeCreationModal] Condition matched - fetching users...");
      const users = await this.getUsers();
      this.setState({ users: users || [] }, () => {
        // Call getUsersWithoutCurrentUser AFTER users state is set
        this.getUsersWithoutCurrentUser();
        this.getCurrentProject();
      });
    } else {
      console.log("[TreeCreationModal] Condition NOT matched - skipping user fetch");
      this.getUsersWithoutCurrentUser();
    }
    let setFocus = document.getElementById("name");
    if (setFocus) {
      setFocus.focus();
    }
  }

  checkUserVariableHaveGlobal(cursor) {
    let isGlobalVariable = false;
    let children = cursor.children;
    if (children && children.length > 0) {
      for (let i = 0; i < children.length; i++) {
        let child = children[i];
        if (child.isGlobal && child.isGlobal === true) {
          isGlobalVariable = true;
          break;
        }
      }
    }
    return isGlobalVariable;
  }

  getUsers() {
    this.setState({ loading: true });
    console.log("[TreeCreationModal] Fetching users from /apis/users...");

    return this.apiService.get(`/apis/users`).then(res => {
      console.log("[TreeCreationModal] API response:", res);
      console.log("[TreeCreationModal] Response type:", typeof res, "Is array:", Array.isArray(res));
      this.setState({ loading: false });
      return res;
    }).catch(err => {
      console.error("[TreeCreationModal] API error:", err);
      this.setState({ loading: false });
      return [];
    });
  }

  getCurrentProject = () => {
    if (this.state.isProject) {
      this.setState({ loading: true });

      return this.apiService.get(`/projects/${this.props.actionElement.id}`).then(res => {
        if (res.success) {
          const { sharedUsers = [] } = res.payload;
          const selectedUsers = sharedUsers
              .map(userId => {
                const match = this.state.users.find(user => user.id === userId);
                return match ? { label: match.name || match.email, value: match.id } : null;
              })
              .filter(Boolean); // remove nulls
          this.setState({ selectedUsers });
        }
        this.setState({ loading: false });
      });
    }
  };

  generateBody = () => {
    if (this.state.isRoot || this.state.isProject) {
      return {
        name: this.state.fileName.value,
        userIds: this.state.selectedUsers.map(item => item.value)
      };
    }
    if ((this.state.elementType || "").toLowerCase() === "crawler") {
      return {
        name: this.state.fileName.value,
        url: this.state.crawlerUrl,
        pageLimit: this.state.crawlerPageLimit,
        requireAuth: this.state.crawlerRequireAuth
      };
    }
    return {
      name: this.state.fileName.value,
      isGlobal: this.state.elementType === "variable" ? this.state.isGlobal : null
    };
  };

  stateChange = (newState = {}) => {
    this.setState(() => ({
      ...this.state,
      ...newState
    }));
  };

  saveFile = () => {
    const tostError = (val, name) => {
      const tostId = `toastId${val}`;
      if (toast.isActive(this[tostId])) return;
      this[tostId] = toast.error(`You can't create more than ${val} ${name}`);
    };

    const { actionElement, save } = this.props;
    if (
      actionElement.name === "Projects" &&
      (actionElement.children.length === 25 || actionElement.children.length > 25)
    ) {
      tostError(25, "projects");
    } else if (
      actionElement.name === "Datasources" &&
      (actionElement.children.length === 100 || actionElement.children.length > 100)
    ) {
      tostError(100, "datasheets");
    } else if (this.dataFlowForFileValidators()) {
      save(this.generateBody());
    }
  };

  isValidFileName = (fileName = this.state.fileName.value) => {
    let siblings = [];
    const currentProject = this.props.originalData.children.find(
      item => item.id === this.props.actionElement.projectID
    );
    if (this.state.isNewFile) {
      siblings = this.props.actionElement.children || [];
    } else {
      if (this.state.isProject) {
        siblings = this.props.originalData.children || [];
      }
      if (this.props.actionElement.elementType === treeElementTypes.component) {
        const currentDatasource =
          currentProject && currentProject.children.find(item => item.contentType === "component");
        siblings = currentDatasource.children || [];
      }
      if (this.props.actionElement.elementType === treeElementTypes.project) {
        siblings = this.props.originalData.children || [];
      }
      if (this.props.actionElement.elementType === treeElementTypes.group) {
        siblings = currentProject.children || [];
      }
      if (this.props.actionElement.elementType === treeElementTypes.dataSource) {
        const currentDatasource =
          currentProject && currentProject.children.find(item => item.contentType === "datasource");
        siblings = currentDatasource.children || [];
      }
      if (this.props.actionElement.elementType === treeElementTypes.flow) {
        const currentFlows = currentProject && currentProject.children.find(item => item.contentType === "flow");
        siblings = currentFlows.children || [];
      }
      if (this.props.actionElement.elementType === treeElementTypes.script) {
        const currentScript = currentProject && currentProject.children.find(item => item.contentType === "script");
        siblings = currentScript.children || [];
      }
      if (this.props.actionElement.elementType === treeElementTypes.user) {
        const currentScript = currentProject && currentProject.children.find(item => item.contentType === "variable");
        siblings = currentScript.children || [];
      }
    }
    const isTheSameName = siblings.some(item => item.name.toLowerCase() === fileName.toLowerCase());
    if (isTheSameName) {
      toast.warn(`${fileName} already exists`);
    }
    return !isTheSameName;
  };

  onChangeFileName = (fileName = this.state.fileName.value) => {
    let value = fileName.trim();
    value = value.replace(/[^a-zA-Z0-9]/g, "");
    const hasSpace = /\s/g.test(value);
    const errMsg = hasSpace ? "Filename should not contain space characters" : null;
    const isValid = !!value && !hasSpace && this.isValidFileName(value);
    this.stateChange({
      fileName: {
        value,
        isValid,
        errMsg
      }
    });
  };

  dataFlowForFileValidators = () => {
    return (
      this.state.fileName.value &&
      (this.state.fileName.isValid || (this.props.actionElement && this.state.fileName.isValid))
    );
  };

  getUsersWithoutCurrentUser() {
    const curEmail = AuthService.user && AuthService.user.email ? AuthService.user.email : "";
    const curUserId = AuthService.user && AuthService.user.id ? AuthService.user.id : "";
    const currentDomain = curEmail.substring(curEmail.lastIndexOf("@") + 1);

    console.log("[TreeCreationModal] getUsersWithoutCurrentUser called");
    console.log("[TreeCreationModal] Current user:", curEmail, "Domain:", currentDomain);
    console.log("[TreeCreationModal] Users in state:", this.state.users?.length || 0);

    const filteredUsers = (this.state.users || []).filter(user => {
      if (!user || !user.email) return false;
      const userDomain = user.email.substring(user.email.lastIndexOf("@") + 1);
      return (
          user.id !== curUserId &&
          user.email.toLowerCase() !== curEmail.toLowerCase() &&
          userDomain === currentDomain
      );
    });

    console.log("[TreeCreationModal] Filtered users (same domain, excluding current):", filteredUsers.length);

    const seenIds = {};
    const userList = [];

    for (let i = 0; i < filteredUsers.length; i++) {
      const u = filteredUsers[i];
      if (!seenIds[u.id]) {
        seenIds[u.id] = true;
        userList.push({ label: u.email, value: u.id });
      }
    }

    console.log("[TreeCreationModal] Final userList for dropdown:", userList);

    if (userList.length > 0) {
      this.setState({ userList });
    }
  }


  render() {
    const elementTypeLower = (this.state.elementType || 'item').toLowerCase();
    let element = elementTypeLower === "datasource" ? "DataSheet" : elementTypeLower;
    element =
      element === "script"
        ? "JS"
        : this.state.elementType === "ROOT"
        ? "Project"
        : element.charAt(0).toUpperCase() + element.slice(1);
    const { modalTitle } = this.props;
    const title = modalTitle
      ? modalTitle
      : `${this.state.isNewFile ? "Create" : this.state.isCopyFile ? "Duplicate" : "Update"} ${
          element === "Api" || element === "api"
            ? "API"
            : element === "Connection" || element === "connection"
            ? "Database"
            : element === "variable" || element === "Variable"
            ? "Variable Sheet"
            : element
        }`;

    // Get icon based on element type
    const getIcon = () => {
      const type = elementTypeLower;
      switch (type) {
        case 'root':
        case 'project':
          return 'fa-folder-plus';
        case 'component':
          return 'fa-cube';
        case 'flow':
          return 'fa-project-diagram';
        case 'script':
          return 'fa-file-code';
        case 'datasource':
          return 'fa-database';
        case 'api':
          return 'fa-plug';
        case 'connection':
          return 'fa-database';
        case 'variable':
          return 'fa-sliders-h';
        default:
          return 'fa-plus-circle';
      }
    };

    return (
      <div className="modern-modal-wrapper">
        <style>{`
          /* Base/Dark theme styles */
          .modern-modal-wrapper .modern-modal-content {
            background: linear-gradient(145deg, #1e2130 0%, #252a3d 100%);
            border-radius: 12px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.05);
            min-width: 420px;
            max-width: 500px;
            overflow: hidden;
          }
          .modern-modal-wrapper .modern-modal-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 24px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.08);
          }
          .modern-modal-wrapper .modern-modal-title {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 18px;
            font-weight: 600;
            color: #fff;
            margin: 0;
          }
          .modern-modal-wrapper .modern-modal-title i {
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
            border-radius: 8px;
            font-size: 16px;
          }
          .modern-modal-wrapper .modern-modal-close {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.05);
            border: none;
            border-radius: 8px;
            color: #9ca3af;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 18px;
          }
          .modern-modal-wrapper .modern-modal-close:hover {
            background: rgba(239, 68, 68, 0.2);
            color: #ef4444;
          }
          .modern-modal-wrapper .modern-modal-body {
            padding: 24px;
          }
          .modern-modal-wrapper .modern-form-group {
            margin-bottom: 20px;
          }
          .modern-modal-wrapper .modern-form-group:last-child {
            margin-bottom: 0;
          }
          .modern-modal-wrapper .modern-form-label {
            display: block;
            font-size: 13px;
            font-weight: 500;
            color: #9ca3af;
            margin-bottom: 8px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .modern-modal-wrapper .modern-form-label.required::after {
            content: ' *';
            color: #ef4444;
          }
          .modern-modal-wrapper .modern-form-input {
            width: 100%;
            padding: 12px 16px;
            background: rgba(0, 0, 0, 0.2);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            color: #fff;
            font-size: 14px;
            transition: all 0.2s ease;
            box-sizing: border-box;
          }
          .modern-modal-wrapper .modern-form-input:focus {
            outline: none;
            border-color: #6366f1;
            box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
          }
          .modern-modal-wrapper .modern-form-input::placeholder {
            color: #6b7280;
          }
          .modern-modal-wrapper .modern-form-input.is-invalid {
            border-color: #ef4444;
          }
          .modern-modal-wrapper .modern-form-error {
            display: block;
            margin-top: 6px;
            font-size: 12px;
            color: #ef4444;
          }
          .modern-modal-wrapper .modern-checkbox-group {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .modern-modal-wrapper .modern-checkbox {
            width: 20px;
            height: 20px;
            accent-color: #6366f1;
            cursor: pointer;
          }
          .modern-modal-wrapper .modern-checkbox-label {
            color: #d1d5db;
            font-size: 14px;
            cursor: pointer;
          }
          .modern-modal-wrapper .modern-modal-footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 12px;
            padding: 16px 24px;
            background: rgba(0, 0, 0, 0.15);
            border-top: 1px solid rgba(255, 255, 255, 0.05);
          }
          .modern-modal-wrapper .modern-btn {
            padding: 10px 20px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            border: none;
          }
          .modern-modal-wrapper .modern-btn-primary {
            background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
            color: #fff;
          }
          .modern-modal-wrapper .modern-btn-primary:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
          }
          .modern-modal-wrapper .modern-btn-primary:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          .modern-modal-wrapper .modern-btn-secondary {
            background: rgba(255, 255, 255, 0.05);
            color: #9ca3af;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }
          .modern-modal-wrapper .modern-btn-secondary:hover {
            background: rgba(255, 255, 255, 0.1);
            color: #fff;
          }
          .modern-modal-wrapper .modern-btn-import {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: #fff;
            margin-right: auto;
          }
          .modern-modal-wrapper .modern-btn-import:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
          }
          .modern-modal-wrapper .react-select-container .react-select__control {
            background: rgba(0, 0, 0, 0.2);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            min-height: 44px;
          }
          .modern-modal-wrapper .react-select-container .react-select__control:hover {
            border-color: rgba(255, 255, 255, 0.2);
          }
          .modern-modal-wrapper .react-select-container .react-select__control--is-focused {
            border-color: #6366f1;
            box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
          }
          .modern-modal-wrapper .react-select-container .react-select__menu {
            background: #1e2130;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
          }
          .modern-modal-wrapper .react-select-container .react-select__option {
            background: transparent;
            color: #d1d5db;
          }
          .modern-modal-wrapper .react-select-container .react-select__option:hover {
            background: rgba(99, 102, 241, 0.2);
          }
          .modern-modal-wrapper .react-select-container .react-select__option--is-selected {
            background: #6366f1;
            color: #fff;
          }
          .modern-modal-wrapper .react-select-container .react-select__multi-value {
            background: rgba(99, 102, 241, 0.3);
            border-radius: 4px;
          }
          .modern-modal-wrapper .react-select-container .react-select__multi-value__label {
            color: #fff;
          }
          .modern-modal-wrapper .react-select-container .react-select__multi-value__remove:hover {
            background: rgba(239, 68, 68, 0.3);
            color: #ef4444;
          }
          .modern-modal-wrapper .react-select-container .react-select__input-container,
          .modern-modal-wrapper .react-select-container .react-select__placeholder {
            color: #6b7280;
          }

          /* Light theme styles */
          .light .modern-modal-wrapper .modern-modal-content {
            background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
          }
          .light .modern-modal-wrapper .modern-modal-header {
            border-bottom: 1px solid #e2e8f0;
          }
          .light .modern-modal-wrapper .modern-modal-title {
            color: #1e293b;
          }
          .light .modern-modal-wrapper .modern-modal-close {
            background: #f1f5f9;
            color: #64748b;
          }
          .light .modern-modal-wrapper .modern-modal-close:hover {
            background: rgba(239, 68, 68, 0.1);
            color: #ef4444;
          }
          .light .modern-modal-wrapper .modern-form-label {
            color: #475569;
          }
          .light .modern-modal-wrapper .modern-form-input {
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            color: #1e293b;
          }
          .light .modern-modal-wrapper .modern-form-input:focus {
            border-color: #6366f1;
            box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
          }
          .light .modern-modal-wrapper .modern-form-input::placeholder {
            color: #94a3b8;
          }
          .light .modern-modal-wrapper .modern-checkbox-label {
            color: #475569;
          }
          .light .modern-modal-wrapper .modern-modal-footer {
            background: #f8fafc;
            border-top: 1px solid #e2e8f0;
          }
          .light .modern-modal-wrapper .modern-btn-secondary {
            background: #f1f5f9;
            color: #475569;
            border: 1px solid #e2e8f0;
          }
          .light .modern-modal-wrapper .modern-btn-secondary:hover {
            background: #e2e8f0;
            color: #1e293b;
          }
          .light .modern-modal-wrapper .react-select-container .react-select__control {
            background: #f8fafc;
            border: 1px solid #e2e8f0;
          }
          .light .modern-modal-wrapper .react-select-container .react-select__control:hover {
            border-color: #cbd5e1;
          }
          .light .modern-modal-wrapper .react-select-container .react-select__menu {
            background: #ffffff;
            border: 1px solid #e2e8f0;
          }
          .light .modern-modal-wrapper .react-select-container .react-select__option {
            color: #1e293b;
          }
          .light .modern-modal-wrapper .react-select-container .react-select__option:hover {
            background: rgba(99, 102, 241, 0.1);
          }
          .light .modern-modal-wrapper .react-select-container .react-select__multi-value {
            background: rgba(99, 102, 241, 0.15);
          }
          .light .modern-modal-wrapper .react-select-container .react-select__multi-value__label {
            color: #6366f1;
          }
          .light .modern-modal-wrapper .react-select-container .react-select__input-container,
          .light .modern-modal-wrapper .react-select-container .react-select__placeholder {
            color: #94a3b8;
          }
          .light .modern-modal-wrapper .react-select-container .react-select__single-value {
            color: #1e293b;
          }

          /* Modern Blue theme styles */
          .modern-blue .modern-modal-wrapper .modern-modal-content {
            background: linear-gradient(145deg, #1e3a5f 0%, #2d4a75 100%);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(59, 130, 246, 0.2);
          }
          .modern-blue .modern-modal-wrapper .modern-modal-header {
            border-bottom: 1px solid rgba(59, 130, 246, 0.3);
          }
          .modern-blue .modern-modal-wrapper .modern-modal-title {
            color: #e0ebff;
          }
          .modern-blue .modern-modal-wrapper .modern-modal-title i {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          }
          .modern-blue .modern-modal-wrapper .modern-modal-close {
            background: rgba(59, 130, 246, 0.15);
            color: #93c5fd;
          }
          .modern-blue .modern-modal-wrapper .modern-modal-close:hover {
            background: rgba(239, 68, 68, 0.2);
            color: #ef4444;
          }
          .modern-blue .modern-modal-wrapper .modern-form-label {
            color: #bfdbfe;
          }
          .modern-blue .modern-modal-wrapper .modern-form-input {
            background: rgba(59, 130, 246, 0.1);
            border: 1px solid rgba(59, 130, 246, 0.3);
            color: #e0ebff;
          }
          .modern-blue .modern-modal-wrapper .modern-form-input:focus {
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
          }
          .modern-blue .modern-modal-wrapper .modern-form-input::placeholder {
            color: #93c5fd;
          }
          .modern-blue .modern-modal-wrapper .modern-checkbox-label {
            color: #bfdbfe;
          }
          .modern-blue .modern-modal-wrapper .modern-checkbox {
            accent-color: #3b82f6;
          }
          .modern-blue .modern-modal-wrapper .modern-modal-footer {
            background: rgba(59, 130, 246, 0.1);
            border-top: 1px solid rgba(59, 130, 246, 0.3);
          }
          .modern-blue .modern-modal-wrapper .modern-btn-primary {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          }
          .modern-blue .modern-modal-wrapper .modern-btn-primary:hover:not(:disabled) {
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }
          .modern-blue .modern-modal-wrapper .modern-btn-secondary {
            background: rgba(59, 130, 246, 0.15);
            color: #bfdbfe;
            border: 1px solid rgba(59, 130, 246, 0.3);
          }
          .modern-blue .modern-modal-wrapper .modern-btn-secondary:hover {
            background: rgba(59, 130, 246, 0.25);
            color: #e0ebff;
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__control {
            background: rgba(59, 130, 246, 0.1);
            border: 1px solid rgba(59, 130, 246, 0.3);
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__control:hover {
            border-color: rgba(59, 130, 246, 0.5);
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__control--is-focused {
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__menu {
            background: #2d4a75;
            border: 1px solid rgba(59, 130, 246, 0.3);
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__option {
            color: #e0ebff;
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__option:hover {
            background: rgba(59, 130, 246, 0.2);
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__option--is-selected {
            background: #3b82f6;
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__multi-value {
            background: rgba(59, 130, 246, 0.3);
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__multi-value__label {
            color: #e0ebff;
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__input-container,
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__placeholder {
            color: #93c5fd;
          }
          .modern-blue .modern-modal-wrapper .react-select-container .react-select__single-value {
            color: #e0ebff;
          }
        `}</style>
        <div className="modern-modal-content">
          <form onSubmit={event => event.preventDefault()}>
            <div className="modern-modal-header">
              <h4 className="modern-modal-title">
                <i className={`fas ${getIcon()}`}></i>
                {title}
              </h4>
              <button type="button" className="modern-modal-close" onClick={this.props.close}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modern-modal-body">
              {(this.state.isNewFile || this.state.isCopyFile) && (
                <div className="modern-form-group">
                  <label className="modern-form-label required" htmlFor="name">
                    Name
                  </label>
                  <input
                    className={`modern-form-input ${this.state.fileName.errMsg ? "is-invalid" : ""}`}
                    id="name"
                    onChange={event => catchingErrorsMaxLengthFileName(event.target.value, this.onChangeFileName)}
                    value={this.state.fileName.value}
                    type="text"
                    placeholder={`Enter ${element.toLowerCase()} name`}
                    maxLength={255}
                    autoFocus
                  />
                  {this.state.fileName.errMsg && (
                    <span className="modern-form-error">{this.state.fileName.errMsg}</span>
                  )}
                </div>
              )}
              {(this.state.elementType || "").toLowerCase() === "crawler" && this.state.isNewFile && (
                <>
                  <div className="modern-form-group">
                    <label className="modern-form-label required" htmlFor="crawlerUrl">
                      URL to crawl
                    </label>
                    <input
                      className="modern-form-input"
                      id="crawlerUrl"
                      type="text"
                      placeholder="https://example.com"
                      value={this.state.crawlerUrl}
                      onChange={e => this.setState({ crawlerUrl: e.target.value })}
                    />
                  </div>
                  <div className="modern-form-group">
                    <label className="modern-form-label" htmlFor="crawlerPageLimit">
                      Page limit (0 = unlimited)
                    </label>
                    <input
                      className="modern-form-input"
                      id="crawlerPageLimit"
                      type="number"
                      min={0}
                      value={this.state.crawlerPageLimit}
                      onChange={e => this.setState({ crawlerPageLimit: Number(e.target.value) || 0 })}
                    />
                  </div>
                  <div className="modern-form-group">
                    <div className="modern-checkbox-group">
                      <input
                        onChange={() => this.setState({ crawlerRequireAuth: !this.state.crawlerRequireAuth })}
                        name="crawlerRequireAuth"
                        type="checkbox"
                        checked={this.state.crawlerRequireAuth}
                        className="modern-checkbox"
                        id="crawlerRequireAuthCheckbox"
                      />
                      <label className="modern-checkbox-label" htmlFor="crawlerRequireAuthCheckbox">
                        Search for login/auth forms
                      </label>
                    </div>
                  </div>
                </>
              )}
              {this.state.elementType === "variable" && !this.state.isShowGlobal && (
                <div className="modern-form-group">
                  <div className="modern-checkbox-group">
                    <input
                      onChange={e => this.setState({ isGlobal: !this.state.isGlobal })}
                      name="isGlobal"
                      type="checkbox"
                      checked={this.state.isGlobal}
                      className="modern-checkbox"
                      id="isGlobalCheckbox"
                    />
                    <label className="modern-checkbox-label" htmlFor="isGlobalCheckbox">
                      Make this a global variable
                    </label>
                  </div>
                </div>
              )}
              {(this.state.isRoot || this.state.isProject) && (
                <div className="modern-form-group">
                  <label className="modern-form-label" htmlFor="users">
                    Share with users
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    className="react-select-container"
                    options={this.state.userList ? this.state.userList : []}
                    value={this.state.selectedUsers}
                    onChange={selectedUsers => this.setState({ selectedUsers })}
                    id="id"
                    name="id"
                    placeholder="Select users to share with..."
                    isMulti
                    isClearable
                  />
                </div>
              )}
            </div>
            <div className="modern-modal-footer">
              {element && (element.toLowerCase() === "api" || element.toLowerCase() === "graphql" || element.toLowerCase() === "variable") && (
                <button
                  onClick={() => this.props.setPostmanModal(element.toLowerCase() === "graphql" ? "api" : element.toLowerCase())}
                  type="button"
                  className="modern-btn modern-btn-import"
                >
                  Import Postman
                </button>
              )}
              {element && element.toLowerCase() === "api" && (
                <button
                  onClick={() => this.props.setPostmanModal("variable")}
                  type="button"
                  className="modern-btn modern-btn-import"
                  style={{ background: '#059669' }}
                >
                  Import Variables
                </button>
              )}
              {/* Swagger FLOWS: multi-step sequences derived from the
                  spec, as opposed to the per-endpoint spec import. */}
              {element && element.toLowerCase() === "api" && this.props.setSwaggerFlowModal && (
                <button
                  onClick={() => this.props.setSwaggerFlowModal()}
                  type="button"
                  className="modern-btn modern-btn-import"
                  style={{ background: '#7c3aed' }}
                  title="Derive multi-step flows from an OpenAPI or Swagger specification"
                >
                  Import Swagger Flows
                </button>
              )}
              <button
                onClick={this.props.close}
                type="button"
                className="modern-btn modern-btn-secondary"
              >
                Cancel
              </button>
              <button
                disabled={!this.dataFlowForFileValidators()}
                onClick={this.saveFile}
                type="submit"
                className="modern-btn modern-btn-primary"
              >
                {this.state.isNewFile ? 'Create' : this.state.isCopyFile ? 'Duplicate' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
